module.exports = __webpack_public_path__ + "img/wind.045144dd.png";